module.exports = __webpack_public_path__ + "img/M800.a3075179.jpg";